import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { $journalApi } from "@/entities/journal/fetch/fetch-client";
import { queryClient } from "@/shared/lib/react-query";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";

export const useCreateSectionOneEntry = (
  sectionOneId: string,
  search?: string,
) => {
  return $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-one/{sectionOneId}",
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({ sectionOneId, search })
            .queryKey,
        });
        notification.success({
          message: NOTIFICATION_MESSAGES.ENTRY_ADDED_SUCCESS, // "Запись успешно добавлена"
          description: NOTIFICATION_MESSAGES.ENTRY_ADDED_SUCCESS, // "Запись успешно добавлена"
        });
      },
      onError: () => {
        notification.error({
          message: NOTIFICATION_MESSAGES.ENTRY_ADD_ERROR, // "Ошибка при добавлении записи"
          description: NOTIFICATION_MESSAGES.ENTRY_ADD_ERROR, // "Ошибка при добавлении записи"
        });
      },
    },
  );
};

export const useUpdateSectionOneEntry = (
  sectionOneId: string,
  search?: string,
) => {
  return $journalApi.useMutation(
    "put",
    "/api/v1/journals/section-one/items/{itemNoVersionId}",
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({ sectionOneId, search })
            .queryKey,
        });
        notification.success({
          message: NOTIFICATION_MESSAGES.ENTRY_UPDATED_SUCCESS, // "Запись успешно обновлена"
          description: NOTIFICATION_MESSAGES.ENTRY_UPDATED_SUCCESS, // "Запись успешно обновлена"
        });
      },
      onError: () => {
        notification.error({
          message: NOTIFICATION_MESSAGES.ENTRY_UPDATE_ERROR, // "Ошибка при обновлении записи"
          description: NOTIFICATION_MESSAGES.ENTRY_UPDATE_ERROR, // "Ошибка при обновлении записи"
        });
      },
    },
  );
};

export const useUpdateSectionOneWithSign = (
  sectionOneId: string,
  search?: string,
) => {
  return $journalApi.useMutation(
    "put",
    "/api/v1/journals/section-one/{sectionOneListId}/items/{versionId}/update",
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({ sectionOneId, search })
            .queryKey,
        });
        notification.success({
          message: NOTIFICATION_MESSAGES.ENTRY_UPDATED_WITH_SIGN_SUCCESS, // "Запись успешно обновлена с подписью"
          description: NOTIFICATION_MESSAGES.ENTRY_UPDATED_WITH_SIGN_SUCCESS, // "Запись успешно обновлена с подписью"
        });
      },
      onError: () => {
        notification.error({
          message: NOTIFICATION_MESSAGES.ENTRY_UPDATE_WITH_SIGN_ERROR, // "Ошибка при обновлении записи с подписью"
          description: NOTIFICATION_MESSAGES.ENTRY_UPDATE_WITH_SIGN_ERROR, // "Ошибка при обновлении записи с подписью"
        });
      },
    },
  );
};
